import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-check\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 298.666667L384 810.666667l-234.666667-234.666667 60.16-60.16L384 689.92 835.84 238.506667 896 298.666667z\" fill=\"\" p-id=\"21048\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol